import SocialMediaShareButtons from '@polydice/ui/dist/SocialMediaShareButtons';
import styles from './style.module.scss';
import classNames from 'classnames';

const SocialMedia = ({ darkMode, ...props }) => {
  return (
    <div
      className={classNames(styles.socialMedia, {
        'dark-mode': darkMode
      })}
    >
      <span>分享至：</span>
      <SocialMediaShareButtons
        {...props}
        className={styles.socialMediaLinks}
        utmCampaign="market-share"
      />
    </div>
  );
};

export default SocialMedia;
